import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from '@/auth/AuthProvider';

export function AppProviders({ children }: PropsWithChildren) {
  const [client] = useState(() => new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
  }));
  return <QueryClientProvider client={client}><AuthProvider>{children}<ToastContainer position="top-right" autoClose={3000} newestOnTop closeOnClick pauseOnHover theme="light" /></AuthProvider></QueryClientProvider>;
}
